// extracted by mini-css-extract-plugin
export default {"select":"MaterialSelector_select__-iGbW"};